import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Modal,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 400,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%',
  },
  container: {
    marginTop: theme.spacing(3),
    height: 200,
  },
  actions: {
    justifyContent: 'flex-end',
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginRight: '24px',
  },
  closeIcon: {
    cursor: 'pointer',
  },
}));

function CustomModal({
  open,
  onModalClick,
  onButtonClick,
  className,
  modalTitle,
  buttonText,
  buttonDisable,
  ...rest
}) {
  const classes = useStyles();

  if (!open) {
    return null;
  }

  return (
    <Modal onClose={onModalClick} open={open}>
      <Card {...rest} className={clsx(classes.root, className)}>
        {modalTitle ? (
          <div className={classes.spaceBetween}>
            <CardHeader title={modalTitle} />
            <CloseIcon onClick={onModalClick} className={classes.closeIcon} />
          </div>
        ) : null}
        <Divider />
        <CardContent>{rest.children}</CardContent>
        <CardActions className={classes.actions}>
          <Button
            color="primary"
            onClick={onButtonClick}
            variant="contained"
            disabled={buttonDisable}
          >
            {buttonText}
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
}

export { CustomModal };
